import React, { FC, useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Container from "@material-ui/core/Container";
import Box from "@material-ui/core/Box";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { Link } from "react-router-dom";
import UserModel from "../../models/user-model";
import TextFieldPassword from "../../components/TextFieldPassword";
import { utilities } from "../../helpers/utilities";
import Title from "../../components/Title";
import { useStyles } from "./styles";
import ButtonComponent from "../../components/ButtonComponent";
import * as Validations from "../../helpers/validations";
import SnackBarAlert from "../../components/Alerts/AlertComponent";
import {
  updatePassword,
  clearPassword,
} from "../../flux/actions/updatePass-actions";
import ScreenLoader from "../../components/ScreenLoader";
import { useHistory } from "react-router-dom";


const CheckPassowrd: FC = () => {
  let history = useHistory();
  const classes = useStyles();
  //Redux
  const dispatcher = useDispatch();

  const updatePasswordState = useSelector(
    (state: any) => state.updatePasswordReducer
  );
  const user: UserModel = useSelector((state: any) => state.authReducer.user);

  const { loading, success, errorMessage } = updatePasswordState;
  //Input errors of the component
  const [errors, setErrors] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  // Here we are storaging  the input declaration according the hooks

  const [currentPass, setCurrentPassword] = useState("");
  const [newPass, setNewPassword] = useState("");
  const [validatePass, setValidatePassword] = useState("");
  const [validateContent, setValidateContent] = useState(true);

  useEffect(() => {
    dispatcher(clearPassword());
  }, [dispatcher]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (currentPass.length > 0 && newPass.length > 0 && validatePass.length > 0) {
      setValidateContent(false)
    }
    else setValidateContent(true);
  }, [currentPass, newPass, validatePass])

  useEffect(() => {
    if (user && !user.id) window.location.href = "/pageNotFound";
  }, [user]);

  useEffect(() => {
    if (success) {
      setCurrentPassword("");
      setNewPassword("");
      setValidatePassword("");
      setValidateContent(true)
    }
  }, [success]);


  const cancel = () => {
    history.push('/perfil')


  };

  const letsChange = (e: React.FormEvent<HTMLFormElement>) => {
    //We prevent reload webpage before submitting
    e.preventDefault();
    //Declare the error of a variable from an errors list
    //In this case are validations
    const errorCurrentPassL = Validations.validate(
      [Validations.required, Validations.maxLength50, Validations.minLength6],
      currentPass
    );

    const errorNewPassL = Validations.validate(
      [Validations.required, Validations.maxLength50, Validations.minLength6],
      newPass
    );
    const errorValidatePassL2 = Validations.validate(
      [Validations.required, Validations.maxLength50, Validations.minLength6],
      validatePass
    );

    const errorValidatePassL = Validations.matchPasswords(
      validatePass.trim(),
      newPass.trim()
    );
    //Here we declare the gotten errors
    setErrors({
      currentPassword: errorCurrentPassL,
      newPassword: errorNewPassL,
      confirmPassword: errorValidatePassL
        ? errorValidatePassL
        : errorValidatePassL2,
    });
    //if we found some error, dont permit the request
    if (
      errorCurrentPassL ||
      errorNewPassL ||
      errorValidatePassL ||
      errorValidatePassL2
    ) {
      return;
    } else {
      //if there is not error, let's move on

      dispatcher(
        updatePassword({
          user: {
            id: user.id,
            newPassword: newPass.trim(),
            currentPassword: currentPass.trim(),
          },
        })
      );
    }
  };

  return (
    <Box mt={5} mb={5}>
      <Container component="main" maxWidth="sm">
        <ScreenLoader isOpen={loading} />
        <form onSubmit={letsChange} className={classes.form}>
          <div className={classes.headerSection}>
            <Link to="/perfil" className={classes.arrowBack}>
              <ArrowBackIcon />
            </Link>
            <Title value="Cambiar Contraseña" className={classes.title} />
          </div>
          <TextFieldPassword
            typeId={"curPasswordID"}
            error={utilities.returnErrorFlag(errors.currentPassword)}
            helperText={errors.currentPassword}
            label={"Contraseña actual"}
            value={currentPass}
            maxLength={50}
            onChange={(e) => {
              setCurrentPassword(e.target.value);
              setErrors({ ...errors, currentPassword: "" });
            }}
          />
          <TextFieldPassword
            error={utilities.returnErrorFlag(errors.newPassword)}
            helperText={errors.newPassword}
            label={"Contraseña nueva"}
            value={newPass}
            maxLength={50}
            onChange={(e) => {
              setNewPassword(e.target.value);
              setErrors({ ...errors, newPassword: "" });
            }}
          />
          <TextFieldPassword
            error={utilities.returnErrorFlag(errors.confirmPassword)}
            helperText={errors.confirmPassword}
            label={"Confirmar nueva contraseña"}
            value={validatePass}
            maxLength={50}
            onChange={(e) => {
              setValidatePassword(e.target.value);
              setErrors({ ...errors, confirmPassword: "" });
            }}
          />
          <div className={classes.buttonsSection}>
            <ButtonComponent
              type="button"
              value="Cancelar"
              variant="outlined"
              onClick={cancel}
              color="secondary"
            />

            <ButtonComponent
              type="submit"
              value="Guardar"
              variant="contained"
              color="secondary"
              disabled={validateContent}
            />

          </div>
          {errorMessage.length > 0 && (
            <SnackBarAlert
              severity="error"
              message={errorMessage}
              open={true}
            />
          )}

          {success && (
            <SnackBarAlert
              severity="success"
              message="Contraseña Actualizada"
              open={true}
            />
          )}
        </form>
      </Container>
    </Box>
  );
};

export default CheckPassowrd;
